import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import StatusDot, { StatusStyle } from '../../components/Status/StatusDot';
import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { CustomerItem } from './Customers';

const columns: Column[] = [
  {
    id: 'status',
    header: 'Status',
    accessor: (customer: any) => {
      let style: StatusStyle = 'default';
      switch (customer.status) {
        case 'ACTIVE':
          style = 'success';
          break;
        case 'INACTIVE':
          style = 'error';
          break;
      }
      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (customer: any): string => {
      return constantToLabel(customer.status);
    },
    width: 80,
  },
  {
    header: 'Name',
    accessor: 'profile.name',
    width: 300,
  },
  {
    header: 'Account',
    accessor: 'accountNumber',
    width: 150,
  },
  {
    id: 'profile.phones.value',
    header: 'Phone',
    accessor: (row: CustomerItem) => row.profile.phones[0]?.value,
    width: 140,
    sortable: false,
  },
  {
    id: 'profile.emails.value',
    header: 'Email',
    accessor: (row: CustomerItem) => row.profile.emails[0]?.value,
    width: 250,
    sortable: false,
  },
  {
    header: 'Address',
    id: 'profile.contactAddress.street1',
    accessor: (row: CustomerItem) =>
      (row.profile.contactAddress?.street1
        ? row.profile.contactAddress.street1
        : '') +
      (row.profile.contactAddress?.street2
        ? ', ' + row.profile.contactAddress.street2
        : ''),
    width: 300,
  },
  {
    header: 'City',
    accessor: 'profile.contactAddress.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'profile.contactAddress.state',
    width: 80,
  },
  {
    header: 'Zip',
    id: 'profile.contactAddress.zip',
    accessor: (row: CustomerItem) =>
      (row.profile.contactAddress?.zip ? row.profile.contactAddress.zip : '') +
      (row.profile.contactAddress?.zipExt
        ? '-' + row.profile.contactAddress.zipExt
        : ''),
    width: 120,
  },
];

export default columns;
